module.exports = __webpack_public_path__ + "img/folio.ef2230f.jpg";